module.exports = __webpack_public_path__ + "assets_1789978653902/img/guide_ios.431fc979.png";